<template>
  <v-toolbar short class="pa-0 widget-header" :class="widgetClasses" flat>
    <h6 class="body-1 pt-1">{{title}}</h6>
    <v-spacer v-if="addSpacer"></v-spacer>
    <slot name="toolbar" v-if="$vuetify.breakpoint.smAndUp" />
    <slot name="toolbar-ext" v-if="!extVisible" />
    <template v-if="actionMenu" #extension>
      <slot name="toolbar" v-if="!$vuetify.breakpoint.smAndUp" />
      <slot name="toolbar-ext" v-if="extVisible" />
    </template>
    <v-menu
      v-if="actionMenu"
      transition="slide-x-transition"
      offset-y
      left
      attach
      open-on-hover
      :open-on-click="false"
    >
      <template v-slot:activator="{ on }">
        <v-btn class="ml-3" text icon small color="grey darken-2" v-on="on">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item @click="$emit('remove')">
          <v-list-item-icon class="mr-3">
            <v-icon>mdi-delete</v-icon>
          </v-list-item-icon>
          <v-list-item-content class="py-0">
            <v-list-item-title class="body-2">Remove Widget</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-toolbar>
</template>

<script>
export default {
  name: "SearchBar",
  props: {
    title: {
      type: String,
      default: ""
    },
    extBreakpoint: {
      type: String,
      default: "xsOnly"
    },
    extNowrap: {
      type: Boolean
    },
    actionMenu: {
      type: Boolean,
      default: true
    },
    addSpacer:{
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      keyword: "",
      isOutlined: false
    };
  },
  mounted() {
    if (this.setFocus) {
      this.$refs.search.focus();
    }
  },
  computed: {
    extVisible() {
      return (
        this.$vuetify.breakpoint.xsOnly ||
        this.$vuetify.breakpoint[this.extBreakpoint]
      );
    },
    widgetClasses() {
      return [
        this.$vuetify.breakpoint.xsOnly ? "xsOnly" : "",
        this.extNowrap && this.$vuetify.breakpoint.smAndUp ? "nowrap" : ""
      ];
    }
  },
  methods: {
    clearSearch: function() {
      if (this.$vuetify.breakpoint.smAndDown) {
        this.$emit("event");
      }
      this.keyword = "";
      this.$refs.search.blur();
    },
    submitSearch() {
      const keyword = this.keyword;
      if (this.$route.path.includes("dashboard")) {
        let accountId = this.$store.getters["auth/account"].id;
        this.$router.push({
          path: "/accounts/" + accountId + "/campaigns",
          query: { name: keyword }
        });
      } else {
        this.$router.replace({
          path: this.$route.path,
          query: { name: keyword }
        });
      }
    },
    onSearchFocus() {
      this.isOutlined = true;
    },
    onSearchBlur() {
      this.isOutlined = false;
    }
  }
};
</script>

<style>
.widget-header {
  height: auto !important;
  z-index: 1;
  position: relative;
}
.widget-header .v-toolbar__content {
  height: auto !important;
  padding: 0;
  z-index: 1;
}
.widget-header .v-toolbar__extension {
  height: auto !important;
  flex-wrap: wrap;
  margin: 10px -5px;
}
.widget-header.nowrap .v-toolbar__extension {
  flex-wrap: nowrap;
}

.widget-header.xsOnly .v-toolbar__extension {
  padding: 5px;
}
.widget-header .v-toolbar__extension > * {
  justify-content: space-between;
  flex-basis: content;
  margin: 5px;
}
.widget-header.xsOnly .v-toolbar__extension > * {
  flex-basis: 100%;
  margin: 0px !important;
}
.widget-header.xsOnly .v-toolbar__extension > * + * {
  margin-top: 5px !important;
}
.widget-header .v-list-item .v-list-item__content .v-list-item__title {
  font-size: 14px !important;
}
.widget-header .v-list-item .v-list-item__icon i {
  font-size: 20px;
}
.widget-header .v-input__icon.v-input__icon--append {
  margin-top: -12px !important;
}
</style>